import { Attributes, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class IDType extends ModelBase {

    public idTypeId: number = 0;

    @Rules.Required()
    @Rules.StringLength(50)
    public idTypeName: string = "";

    public deletedBy: number | null = null;

    @Attributes.Date()
    public deletedOn: Date | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.idTypeName) {
            return "New id type";
        } else {
            return this.idTypeName;
        }
    }
}
